import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "govuk-heading-l" }, "Page not found", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body" }, " If you typed the web address, check it is correct. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body" }, " If you pasted the web address, check you copied the entire address. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3
  ], 64))
}